import React from 'react';
import { makeStyles, Button, CircularProgress } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {},
    label: {
        lineHeight: '20px',
        paddingTop: '6px',
        paddingBottom: '6px',
        fontSize: '15px',
        fontWeight: 500,
        textTransform: 'none',
    },
    contained: {
        color: '#000',
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
        '&:hover': {
            backgroundColor: '#EBE9E9',
        },
    },
    containedPrimary: {
        color: '#FFF',
        backgroundColor: '#FC821F',
        '&:hover': {
            backgroundColor: '#FF953F',
        },
    },
    containedSecondary: {
        color: '#FFF',
        backgroundColor: '#1D8A8B',
        '&:hover': {
            backgroundColor: '#289E9F',
        },
    },
}));

const AfitdButton = props => {
    const defaultClasses = useStyles();
    const { classes, isHidden, label, children, className, isGroup = false, size, labelStyles, loading, color, ...otherProps } = props;

    const buttonClasses = {
        contained: defaultClasses.contained,
        containedPrimary: defaultClasses.containedPrimary,
        containedSecondary: defaultClasses.containedSecondary,
        label: labelStyles ? labelStyles : isGroup || size !== undefined ? null : defaultClasses.label,
        ...classes,
    };

    const spinnerColor = color === 'primary' ? '#FFF' : undefined;

    if (isHidden) {
        return null;
    } else {
        return (
            <Button disableElevation variant="contained" className={className} classes={buttonClasses} size={size} color={color} {...otherProps}>
                {loading && (
                    <>
                        <CircularProgress size={20} color={spinnerColor} /> &nbsp;
                    </>
                )}{' '}
                {children || label}
            </Button>
        );
    }
};

export default AfitdButton;
